import React, { useState, useCallback, useEffect } from 'react';
import Conexao from '../Config/conexao';
import axios from 'axios';
import Menu from '../Components/Navbar/navbar'
import { useDropzone } from 'react-dropzone'
import './CadastroVisualizador.css';
import { Container, Col, Row, Table, Button, Modal, Spinner } from 'react-bootstrap';
import { BeatLoader, BarLoader } from 'react-spinners';
import { Trash } from 'react-bootstrap-icons';
import Select from 'react-select';
export default function CadastroVisualizador() {
    const [processo, setProcesso] = useState();
    const [dadosprocesso, setDadosProcesso] = useState();
    const [file, setFile] = useState(null);
    const [tipoamostraselect, setTipoAmostraSelect] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [username, setUsername] = useState('');
    const [cargo, setCargo] = useState('');
    const [setor, setSetor] = useState('');
    const [pais, setPais] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [entidadeselected, setEntidadeSelectd] = useState();
    const [obraselectd, setObraSelectd] = useState();
    const [errorMessage, setErrorMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalTrash, setShowModalTrash] = useState(false);
    const [array, setArray] = useState([]);
    const [arraytreinamento, setArrayTreinamento] = useState([]);
    const [arraylogin, setArrayLogin] = useState([]);
    const [lote, setLote] = useState();
    const [amostra, setAmostra] = useState();
    const [isLoading, setIsLoading] = useState();
    const [selectedId, setSelectedId] = useState(0)
    const [name, setName] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoadingprocesso, setIsLoadingProcesso] = useState(false);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = array.slice(indexOfFirstItem, indexOfLastItem);
    const [sondagem, setSondagem] = useState('');
    const [dataRegistro, setDataRegistro] = useState('');
    const [dataPrevisaoSaida, setDataPrevisaoSaida] = useState('');
    const [coordenadaX, setCoordenadaX] = useState('');
    const [coordenadaY, setCoordenadaY] = useState('');
    const [coordenadaZ, setCoordenadaZ] = useState('');
    const [profundidadeInicial, setProfundidadeInicial] = useState('');
    const [profundidadeFinal, setProfundidadeFinal] = useState('');
    const [localizacao, setLocalizacao] = useState('');
    const [localColeta, setLocalColeta] = useState('');
    const [aplicacao, setAplicacao] = useState('');
    const [responsabilidadeAmostragem, setResponsabilidadeAmostragem] = useState('');
    const [bloqueado, setBloqueado] = useState(true)
    const totalPages = Math.ceil(array.length / itemsPerPage);
    const startPage = Math.max(1, currentPage - 5);
    const endPage = Math.min(totalPages, currentPage + 5);
    const [isLoading1, setIsLoading1] = useState(false);
    const [showModalBuscar, setShowModalBuscar] = useState(false);
    const [dadosTreinamento, setDadosTreinamento] = useState([]);
    const handleSubmit = (event) => {
        event.preventDefault();
        // Verificar se todos os campos foram preenchidos
        if (!firstName || !lastName || !username || !cargo || !setor || !pais || !password || !confirmPassword) {
            alert('Por favor, preencha todos os campos.');
            return;
        } else {
            if (password.length >= 6) {
                if (password !== confirmPassword) {
                    setErrorMessage('As senhas não são iguais');
                } else {
                    setErrorMessage('');

                }
            } else {
                setErrorMessage('A senha tem que ter mais de 6 caracteris');
            }
        };
    }

    useEffect(() => {
        BuscarListaTreinamento()
    }, [])



    async function SalvarCadastroAmotra(e) {
        e.preventDefault();

        setIsLoading1(true);

        // Get the selected course
        const selectedCourse = document.getElementById('treinamento').value;
        const selectedDate = document.getElementById('dataTreinamento').value;
        // Initialize an array to hold the course-participant pairs
        const courseParticipantPairs = [];

        // For each participant, get the selected participant and add it to the array
        for (const [index, participante] of participantes.entries()) {
            const selectedParticipant = document.getElementById(`participante${index}`).value;

            // Add the course-participant pair to the array
            courseParticipantPairs.push({
                course: selectedCourse,
                participant: selectedParticipant,
                selectedDate: selectedDate
            });
        }

        console.log(courseParticipantPairs);
        const obj = {
            courseParticipantPairs
        };

        const res = await axios.post(Conexao.api + 'InserirTreinamentos.php', obj);

        console.log('SalvarLista', obj)
        console.log(res.data[0].success)
        if (res.data[0].success === true) {
            alert('Login Salvo com Sucesso!')
            setShowModal(false)
            setIsLoading(false);
            resetForm()
        }

        setIsLoading1(false);
    };
    async function BuscarListaTreinamento() {
        try {
            const res = await axios.get(Conexao.api + 'ListarTreinamento.php');
            console.log(res.data.result);
            setArray(res.data.result);
            BuscarListaLogin()
        } catch (error) {
            console.error(error);
        }
    }

    async function BuscarListaLogin() {
        try {
            const res = await axios.get(Conexao.api + 'ListaLogin.php');
            console.log(res.data.result);
            setArrayLogin(res.data.result);
            BuscarListaTreinamentos()
        } catch (error) {
            console.error(error);
        }
    }
    async function BuscarListaTreinamentos() {
        try {
            const res = await axios.get(Conexao.api + 'ListarTreinamentos.php');
            console.log(res.data.result);
            setArrayTreinamento(res.data.result);

        } catch (error) {
            console.error(error);
        }
    }
    async function BuscarDadosTreinamento() {
        try {
            const res = await axios.get(Conexao.api + 'ListarTreinamentoModal.php');
            console.log(res.data.result);
            setDadosTreinamento(res.data.result);
            setShowModalBuscar(true);
        } catch (error) {
            console.error(error);
        }

    }




    async function listarDados() {
        setIsLoadingProcesso(true);
        try {//BuscarCadastroProcesso.php
            const res = await axios.get(Conexao.api + 'BuscarCadastroProcesso.php?processo=' + processo);
            console.log(res.data);
            if (res.data.result !== '0') {
                setDadosProcesso(res.data.result);
                setAmostra(res.data.amostra);
                setLote(res.data.lote);
                setBloqueado(false)
                setIsLoadingProcesso(false);
            } else {
                alert('Processo não encontrado')
                setIsLoadingProcesso(false);
            }
        } catch (error) {
            console.error(error);
            setIsLoadingProcesso(false);
        }

    }
    const resetForm = () => {
        setProcesso('');
        setAmostra('');
        setTipoAmostraSelect('');
        setEntidadeSelectd('');
        setObraSelectd('');
        setLote('');
        setSondagem('');
        setDataRegistro('');
        setDataPrevisaoSaida('');
        setCoordenadaX('');
        setCoordenadaY('');
        setCoordenadaZ('');
        setProfundidadeInicial('');
        setProfundidadeFinal('');
        setLocalizacao('');
        setLocalColeta('');
        setAplicacao('');
        setResponsabilidadeAmostragem('');
    };
    const [participantes, setParticipantes] = useState([]);

    const addParticipante = () => {
        setParticipantes([...participantes, {}]);
    };
    const removeParticipante = () => {
        // Remove the last participant from the participantes array
        const newParticipantes = participantes.slice(0, -1);
        setParticipantes(newParticipantes);
    };
    async function ExcluirLogin() {

        const obj = {

        };
        //const res = await axios.get(Conexao.api + 'ExcluirLogin.php?id=' + selectedId);
        // console.log(Conexao.api + 'ExcluirLogin.php', obj)
        // if (res.data.success === true) {
        //     setShowModalTrash(false)
        //     alert('Login Excluido com Sucesso!')

        // }

    }
    const handleDateChange = (e) => {
        const date = new Date(e.target.value);
        const formattedDate = date.toISOString().split('T')[0];
        setDataRegistro(formattedDate);
    };


    const handleDateChange2 = (e) => {
        const date = new Date(e.target.value);
        const formattedDate = date.toISOString().split('T')[0];
        setDataPrevisaoSaida(formattedDate);
    };

    const onDrop = useCallback(acceptedFiles => {
        setFile(acceptedFiles[0]);
        console.log(acceptedFiles)
    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })
    if (isLoading) {
        return (
            <body class="bg-light">
                <div>
                    <Menu />
                    <Container style={{ marginTop: '100px' }}>
                        <h2 style={{ textAlign: 'center', marginTop: '60px', color: '#3EBF52' }}>Lista de Cadastro de Amostra</h2>



                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh', marginTop: '0%' }}>
                            <span style={{ color: "#000000", fontSize: '20px' }}>Loading...</span>
                            <BeatLoader color="#FFD700" />



                        </div>




                    </Container>

                </div>
            </body>
        );
    }

    return (<body class="bg-light">
        <div>
            <Menu />
            <Container style={{ marginTop: '100px', marginRight: '60%' }}>

                <h2 style={{ textAlign: 'center', marginTop: '60px', color: '#3EBF52', marginLeft: '50%' }}>Lista de Treinamentos</h2>

                <button class="btnlogin" onClick={() => setShowModal(true)} style={{ float: 'right' }}>Cadastro</button>

                <Row style={{ marginTop: '10%', marginRight: '60%' }}>

                    <Col style={{ marginRight: '60%' }}>
                        <Table >
                            <thead striped bordered hover style={{ backgroundColor: '#3EBF52' }}>
                                <tr>
                                    <th style={{ fontSize: '20px', textAlign: 'center' }}>Processo</th>
                                    <th style={{ fontSize: '20px', textAlign: 'center' }}>Data do Treinamento</th>
                                    <th style={{ fontSize: '20px', textAlign: 'center' }}>Visualizar</th>
                                </tr>
                            </thead>
                            <tbody >
                                {currentItems.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ fontSize: '15px', textAlign: 'center' }}>{item.Treinamento}</td>
                                        <td style={{ fontSize: '15px', textalign: 'center', verticalAlign: 'center', }}>{item.Amostra}</td>


                                        <td style={{ textAlign: 'center' }}>
                                            <Button variant="danger" style={{ marginLeft: 'auto', marginRight: 'auto' }} onClick={() => {
                                                setSelectedId(item.id);
                                                setName(item.nome)
                                                setShowModalTrash(true);
                                            }}>
                                                <Trash />
                                            </Button>
                                        </td>
                                        <button className="fas fa-solid fa-eye  green botaao" data-bs-toggle="modal" data-bs-target="#ModalAcoesReali" onClick={() => {
                                            BuscarDadosTreinamento();
                                            // getAnexo(f.protocolo, f.item1);
                                        }} >
                                        </button>
                                    </tr>
                                ))}
                            </tbody>


                        </Table>
                        <nav aria-label="Navegação de página exemplo">
                            <ul class="pagination">
                                <li className="page-item">
                                    <a
                                        className="page-link"
                                        href="#"
                                        aria-label="Anterior"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
                                        }}
                                    >
                                        <span aria-hidden="true">&laquo;</span>
                                        <span className="sr-only">Anterior</span>
                                    </a>
                                </li>
                                {Array(endPage - startPage + 1).fill().map((_, index) => {
                                    const pageNumber = startPage + index;
                                    return (
                                        <li className="page-item" key={index}>
                                            <a
                                                className="page-link"
                                                onClick={() => setCurrentPage(pageNumber)}
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: currentPage === pageNumber ? 'blue' : 'white'
                                                }}
                                            >
                                                {pageNumber}
                                            </a>
                                        </li>
                                    );
                                })}
                                {endPage < totalPages && <li className="page-item"><a className="page-link">...</a></li>}
                                <li className="page-item">
                                    <a
                                        className="page-link"
                                        href="#"
                                        aria-label="Próximo"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setCurrentPage(prevPage => prevPage + 1);
                                        }}
                                        style={{ visibility: currentPage === totalPages ? 'hidden' : 'visible' }}
                                    >
                                        <span aria-hidden="true">&raquo;</span>
                                        <span className="sr-only">Próximo</span>
                                    </a>
                                </li>
                                <li className="page-item">
                                    <select
                                        className="page-link"
                                        value={itemsPerPage}
                                        onChange={(e) => setItemsPerPage(Number(e.target.value))}
                                        style={{ visibility: currentPage === totalPages && currentPage !== 1 ? 'hidden' : 'visible' }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={30}>30</option>
                                        <option value={40}>40</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </li>
                            </ul>

                        </nav>
                    </Col>

                </Row>
            </Container>

            <div style={{ width: '100%', marginTop: '10%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10%' }}>
                <Modal show={showModalTrash} onHide={() => setShowModalTrash(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de Exclusão</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <BarLoader color="#FFD700" />
                        <p style={{ marginLeft: '10px' }}>Tem certeza de que deseja excluir {name} ?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModalTrash(false)}>
                            Cancelar
                        </Button>
                        <Button variant="danger" >
                            Excluir
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showModal} onHide={() => { setShowModal(false); resetForm(); }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Cadastro</Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <div class="col-md-10 col-lg-10">
                            <div class="row g-3">
                                <div class="col-12">
                                    <label for="treinamento" class="form-label">Treinamento</label>
                                    <select class="form-select" id="treinamento" required>
                                        <option selected>Selecione...</option>
                                        {arraytreinamento.filter(id => id.Status === "1").map((id) => (
                                            <option key={id.Treinamento} value={id.Treinamento}>{id.Treinamento}</option>
                                        ))}
                                    </select>
                                </div>

                                <div class="col-12">
                                    <label for="dataTreinamento" class="form-label">Data do Treinamento</label>
                                    <input type="date" class="form-control" id="dataTreinamento" name="dataTreinamento" required />
                                </div>
                                {participantes.map((participante, index) => (
                                    <div key={index} class="col-16">
                                        <label for={`participante${index}`} class="form-label">Participante</label>
                                        <div class="d-flex align-items-center">
                                            <select class="form-select" id={`participante${index}`} required>
                                                <option selected>Selecione...</option>
                                                {arraylogin.map((id) => (
                                                    <option key={id.nome} value={id.nome}>{id.nome}</option>
                                                ))}
                                            </select>
                                            <div class="col-1">

                                            </div>
                                            <button class="btn btn-danger ml-3" type="button" onClick={() => removeParticipante(index)}>
                                                -
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                <div class="col-12">
                                    <button class="btn btn-primary" type="button" onClick={addParticipante}>
                                        Adicionar Participante
                                    </button>
                                </div>
                            </div>
                            <hr class="my-4"></hr>
                            <button class="w-100 btn btn-primary btn-lg" type="submit" onClick={(e) => SalvarCadastroAmotra(e)}>
                                {isLoading1 ? (
                                    <>
                                        <span style={{ color: "#000000", fontSize: '20px' }}>Loading...</span>
                                        <BeatLoader color="#FFD700" />
                                    </>
                                ) : (
                                    'Salvar'
                                )}
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={showModalBuscar} onHide={() => setShowModalBuscar(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Dados do Treinamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {dadosTreinamento.length > 0 ? (
                            dadosTreinamento.map((treinado, index) => (
                                <div key={index}>
                                    <label>{`Treinado ${index + 1}:`}</label>
                                    <input type="text" value={treinado[1]} readOnly />
                                </div>
                            ))
                        ) : (
                            <p>Nenhum dado de treinamento encontrado.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={() => setShowModal(false)}>Fechar</button>
                    </Modal.Footer>
                </Modal>
            </div>


        </div>
    </body >
    );
}

